import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-screen flex items-center justify-center px-6 pt-20">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="max-w-lg text-center">
        <p className="label text-[#8A8F99] mb-4">Checkout Cancelled</p>
        <h1 className="font-serif-display text-5xl tracking-tight">Your bag is saved</h1>
        <p className="text-[#3A4150] mt-6 text-lg">No charge was made. Your selected pieces are waiting whenever you're ready.</p>
        <Link to="/shop" className="mt-10 inline-flex bg-[#0B0E14] text-[#EDEEF1] px-10 h-14 items-center label hover:bg-[#1B2233] transition-colors">
          Return to Collection
        </Link>
      </motion.div>
    </div>
  );
}
